import type { IconAsset } from '../Icon.types';

const code = (
  <g>
    <path
      d='M6.33341 7.16658C6.33341 6.82141 6.05359 6.54158 5.70841 6.54158C5.36324 6.54158 5.08341 6.82141 5.08341 7.16658V12.1666C5.08341 12.5118 5.36324 12.7916 5.70841 12.7916C6.05359 12.7916 6.33341 12.5118 6.33341 12.1666V7.16658Z'
      fill='#77777A'
    />
    <path
      d='M8.83341 7.16658C8.83341 6.82141 8.55359 6.54158 8.20841 6.54158C7.86324 6.54158 7.58341 6.82141 7.58341 7.16658V12.1666C7.58341 12.5118 7.86324 12.7916 8.20841 12.7916C8.55359 12.7916 8.83341 12.5118 8.83341 12.1666V7.16658Z'
      fill='#77777A'
    />
    <path
      d='M10.7084 6.54158C11.0536 6.54158 11.3334 6.82141 11.3334 7.16658V12.1666C11.3334 12.5118 11.0536 12.7916 10.7084 12.7916C10.3632 12.7916 10.0834 12.5118 10.0834 12.1666V7.16658C10.0834 6.82141 10.3632 6.54158 10.7084 6.54158Z'
      fill='#77777A'
    />
    <path
      clipRule='evenodd'
      d='M6.38393 0.708252C6.17802 0.708252 5.98533 0.809668 5.86875 0.979392L4.19472 3.41658H1.54175C1.19657 3.41658 0.916748 3.69641 0.916748 4.04158C0.916748 4.38676 1.19657 4.66658 1.54175 4.66658H2.79175V13.6249C2.79175 14.6604 3.63121 15.4999 4.66675 15.4999H11.7501C12.7856 15.4999 13.6251 14.6604 13.6251 13.6249V4.66658H14.4584C14.8036 4.66658 15.0834 4.38676 15.0834 4.04158C15.0834 3.69641 14.8036 3.41658 14.4584 3.41658H12.218L10.3128 0.951097C10.1945 0.797935 10.0118 0.708252 9.81827 0.708252H6.38393ZM12.3751 4.66658H4.04175V13.6249C4.04175 13.9701 4.32157 14.2499 4.66675 14.2499H11.7501C12.0953 14.2499 12.3751 13.9701 12.3751 13.6249V4.66658ZM10.6383 3.41658H5.71118L6.71287 1.95825H9.51137L10.6383 3.41658Z'
      fill='#77777A'
      fillRule='evenodd'
    />
  </g>
);
export const remove: IconAsset = {
  bold: {
    l: {
      code,
    },
    m: {
      code,
    },
    s: {
      code,
    },
  },
  regular: {
    l: {
      code,
    },
    m: {
      code,
    },
    s: {
      code,
    },
  },
};
